/**
 * Инструменты работы с телом контента — TipTap-документом (bodyJson).
 * Единственный формат тела (SKUBY-CMS-MODULE-SPEC.md §2.2): витрина рендерит
 * дерево типизированных блоков своими компонентами
 */

export interface ContentBodyMark {
  type: string
  attrs?: Record<string, unknown>
}

export interface ContentBodyNode {
  type: string
  attrs?: Record<string, unknown>
  content?: ContentBodyNode[]
  marks?: ContentBodyMark[]
  text?: string
}

/** Разбор сериализованного тела; битый/пустой вход → пустой список блоков. */
export function parseContentBody(raw: string | null | undefined): ContentBodyNode[] {
  if (!raw) return []
  try {
    const doc = JSON.parse(raw) as ContentBodyNode
    return Array.isArray(doc?.content) ? doc.content : []
  }
  catch {
    return []
  }
}
